import { render, staticRenderFns } from "./room_set_editor.vue?vue&type=template&id=2f7d17f9&"
import script from "./room_set_editor.vue?vue&type=script&lang=js&"
export * from "./room_set_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f7d17f9')) {
      api.createRecord('2f7d17f9', component.options)
    } else {
      api.reload('2f7d17f9', component.options)
    }
    module.hot.accept("./room_set_editor.vue?vue&type=template&id=2f7d17f9&", function () {
      api.rerender('2f7d17f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/venues/room_set_editor.vue"
export default component.exports